import {https, httpsFile} from './http.js';

export function index(page, currentpage,sortby,sortdir, search,plant) {
    return httpsFile().get(`inventoryMonitoring?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&plant=${plant}`);
}
export function getMatgroups(page, search,plant) {
    return httpsFile().get(`getMatgroups?page=${page}&search=${search}&plant=${plant}`);
}

// export function show(id,show){
//     return https().get(`goods_receipt/${id}?showFor=${show}`);
// }
//
// export function showReceivingReport(page, currentpage,sortby,sortdir, search,status, supplier, startDate,endDate) {
//     return httpsFile().get(`showReceivingReport?page=${page}&currentpage=${currentpage}&sortby=${sortby}&sortdir=${sortdir}&search=${search}&status=${status}&supplier=${supplier}&startDate=${startDate}&endDate=${endDate}`);
// }
//
// export function showReceivingReportDetails(id){
//     return https().get(`showReceivingReport/${id}`);
// }
//
export function updateMatGroupPrioSettings(data){
    return https().post(`updateMatGroupPrioSettings`,data);
}
//
// export function getDelivered(MATNR,EBELN,EBELP){
//     return https().get(`getDelivered?MATNR=${MATNR}&EBELN=${EBELN}&EBELP=${EBELP}`);
// }
// export function getStatus(EBELN){
//     return https().get(`getStatus?EBELN=${EBELN}`);
// }
//
// export function getRequestedQty(MATNR,EBELN){
//     return https().get(`getRequestedQty?MATNR=${MATNR}&EBELN=${EBELN}`);
// }
//
// export function xmlExport(data){
//     return https().post(`xmlExport`,data);
// }
//
// export function saveReceivingReport(data){
//     return https().post(`saveReceivingReport`,data);
// }
//
// export function manualExport(id){
//     return https().get(`goodsReceiptManualExport?id=${id}`);
// }